export default "__VITE_ASSET__rE43qBv8__"